// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__HljBZ","dark":"Skeleton_dark__sAoFz","wave":"Skeleton_wave__-OFsT"};